module.exports = __webpack_public_path__ + "img/patrulla_ministerial_up_selected.9768cc1a.svg";